(function () {
    'use strict';

    angular
        .module('crewProfile')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('crewProfile', {
                sticky: true,
                url: '/crew-profile/:crewId?',
                views: {
                    'profileView': {
                        templateUrl: 'profile/views/crew-profile.tpl.html',
                        controller: 'ProfileCtrl',
                        controllerAs: 'crewProfile'
                    }
                }
            });
    }
}());
